
<div *ngIf="status == DONE; else relatedLoading" class="version-related-group">

    <header class="counter-header" [hidden]="total==0">
        <h5>
            <em>{{total}}</em>
            <span [hidden]="total > 1">Version</span>
            <span [hidden]="total < 2">Versions</span>
        </h5>
    </header>
<div *ngIf="loadFeedbacksError !=null" class="related-selector-error">
    <core-helpers-box-alert-message-icon [text]="'There was an error loading artwork files list. <br> Please refresh your screen.<br />If the error persists, please
            reach out to our support team through the Help Me button.'"
        [icon]="'alert'"></core-helpers-box-alert-message-icon>
</div>
    <div>
        <ul class="version-related-group-list">
            <li *ngFor="let group of groups">
                <core-versions-related-group-item-files-list-checkbox 
                    [related]="group" 
                    [selected]="selected"
                    (selectedChange)="onChange($event);"
                    [disabled]="disabled">
                </core-versions-related-group-item-files-list-checkbox>
            </li>
        </ul>
    </div>
</div>
<ng-template #relatedLoading>
    <div class="loader" [hidden]="status != LOADING">
        <div class="dimmed">
            <div class="dimmed_title"></div>
        </div>
        <div class="dimmed">
            <div class="dimmed_title"></div>
        </div>
        <div class="dimmed">
            <div class="dimmed_title"></div>
        </div>
    </div>
</ng-template >
<div *ngIf="status == RELATED_ERROR" class="related-selector-error">
    <core-helpers-box-alert-message-icon [text]="'There was an error loading artwork files list. <br> Please refresh your screen.<br />If the error persists, please
        reach out to our support team through the Help Me button.'"
        [icon]="'alert'"></core-helpers-box-alert-message-icon>
</div>
